

import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useState, useEffect } from "react";
import {
  Grid,
  Card,
  CardHeader,
  CardContent,
  Typography,
  TextField,
  Button,
  FormHelperText,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";


import { addCategoryApi, updateCategoryApi } from "../../../../src/redux/api/api";

const CategoryForm = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const [formValues, setFormValues] = useState({
    name: "",
    image: null,
    hoverimage: null,
    headerimage: null,
  });
 //console.log("formValues", formValues);


  const [image, setImage] = useState("");
  const [hoverimage, setHoverimage] = useState("");
  const [headerimage, setHeaderimage] = useState("");
  const [previewimage, setPreviewimage] = useState("");
  const [visible, setVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (state) {
      setFormValues({
        name: state.name || "",
        image: null,
        hoverimage: null,
        headerimage: null,
      });
      setImage(state.image || "");
      setHoverimage(state.hoverimage || "");
      setHeaderimage(state.headerimage || "");
    } else {
      setFormValues({ name: "", image: null, hoverimage: null, headerimage: null });
      setImage("");
      setHoverimage("");
      setHeaderimage("");
    }
  }, [state]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleSingleImgChange = (e, type) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith("image/")) {
      const url = URL.createObjectURL(file);
      if (type === "image") {
        setImage(url);
        setFormValues((prev) => ({ ...prev, image: file }));
      } else if (type === "headerimage") {
        setHeaderimage(url);
        setFormValues((prev) => ({ ...prev, headerimage: file }));
      } else {
        setHoverimage(url);
        setFormValues((prev) => ({ ...prev, hoverimage: file }));
      }
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formValues.name) newErrors.name = "Category Name is required";
    if (!image) newErrors.image = "Category Image is required";
    if (!hoverimage) newErrors.hoverimage = "Category Hover Image is required";
    if (!headerimage) newErrors.headerimage = "Category Header Image is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      setIsLoading(true);
      const formData = new FormData();

      formData.append("name", formValues.name);
      if (formValues.image) formData.append("image", formValues.image);
      if (formValues.hoverimage) formData.append("hoverimage", formValues.hoverimage);
      if (formValues.headerimage) formData.append("headerimage", formValues.headerimage);

      if (state && state._id) {
        formData.append("id", state._id);
      }

     //console.log("formData", ...formData.entries());

      const apiCall = state ? updateCategoryApi(formData) : addCategoryApi(formData);
      const response = await apiCall;

      if (response.status === 200) {
        toast.success("Category saved successfully!");
        navigate("/category");
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message || "An error occurred. Please try again.";
      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Card>
      <CardHeader
        title={<Typography variant="h6">Category Form</Typography>}
      />
      <CardContent>
        <form onSubmit={onSubmit}>
          <Grid container spacing={3}>
            <Typography variant="subtitle2" gutterBottom>
              Category Name
            </Typography>
            {/* Category Name */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Category Name"
                name="name"
                value={formValues.name}
                onChange={handleChange}
                error={!!errors.name}
                helperText={errors.name}
              />
            </Grid>

            {/* Category Image */}
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2" gutterBottom>
                Category Image
              </Typography>
              <TextField
                fullWidth
                id="image"
                type="file"
                inputProps={{ accept: "image/*" }}
                onChange={(e) => handleSingleImgChange(e, "image")}
                error={!!errors.image}
              />
              {errors.image && <FormHelperText error>{errors.image}</FormHelperText>}
              {image && (
                <img
                  src={image}
                  alt="category"
                  style={{ borderRadius: 8, maxHeight: 120 }}
                />
              )}
            </Grid>



            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2" gutterBottom>
                Category Hover Image
              </Typography>
              <TextField
                fullWidth
                id="hoverimage"
                type="file"
                inputProps={{ accept: "image/*" }}
                onChange={(e) => handleSingleImgChange(e, "hoverimage")}
                error={!!errors.hoverimage}
              />
              {errors.hoverimage && <FormHelperText error>{errors.hoverimage}</FormHelperText>}
              {hoverimage && (
                <img
                  src={hoverimage}
                  alt="hover preview"
                  style={{ borderRadius: 8, maxHeight: 120 }}
                />
              )}
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2" gutterBottom>
                Header Image
              </Typography>
              <TextField
                fullWidth
                id="headerimage"
                type="file"
                inputProps={{ accept: "image/*" }}
                onChange={(e) => handleSingleImgChange(e, "headerimage")}
                error={!!errors.headerimage}
              />
              {errors.headerimage && <FormHelperText error>{errors.headerimage}</FormHelperText>}
              {headerimage && (
                <img
                  src={headerimage}
                  alt="header preview"
                  style={{ borderRadius: 8, maxHeight: 120 }}
                />
              )}
            </Grid>

            {/* Submit Button */}
            <Grid item xs={12} textAlign="center">
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={isLoading}
              >
                {isLoading ? "Submitting..." : "Submit"}
              </Button>
            </Grid>

          </Grid>
        </form>
      </CardContent>
    </Card>

  );
};

export default CategoryForm;
